import Button from "react-bootstrap/Button";

export default function ContactAgent() {
  return (
    <>
      <Button>Contact an Agent</Button>
    </>
  );
}
